import { UserPermissions } from '@/types/user';

export const BILLING_VIEW_BILLING = 'billing.view_billing_dashboard';
export const AUDITLOG_VIEW_LOGENTRY = 'auditlog.view_logentry';

export const CHALLENGES_VIEW_USER_CHALLENGE_IMAGE = 'challenges.view_userchallengeimage';
export const PEOPLE_VIEW_SECRET = 'vault.view_secret';
export const PEOPLE_CHANGE_SECRET = 'vault.change_secret';

export const PEOPLE_NEW_DRUG_SCREEN = 'drug_screens.add_drugscreen';

export const PEOPLE_VIEW_AI_PROFILE = 'people.view_ai_profile';
export const PEOPLE_VIEW_TIMELINE = 'people.view_activitylog';
export const PEOPLE_VIEW_ENCOUNTERS = 'billing.view_encounter';
export const PEOPLE_MARK_NON_BILLABLE = 'billing.modify_billable';
export const PEOPLE_VIEW_REWARD_CARDS = 'reward_cards.view_card';
export const PEOPLE_IMPERSONATE = 'people.impersonate';
export const USER_RESET_MFA = 'user.reset_mfa';
export const PEOPLE_CHANGE_REWARD_CARDS = 'reward_cards.change_card';
export const PEOPLE_ORDER_REWARD_CARDS = 'reward_cards.add_cardorder';
export const PEOPLE_CHANGE_ROLE_SETTINGS = 'people.change_rolesettings';
export const PEOPLE_AVAILABILITY_VIEW = 'people.view_availability';
export const PEOPLE_AVAILABILITY_CHANGE = 'people.change_availability';
export const PEOPLE_INSURANCE_POLICY_ADMINISTRATOR = 'insurance.manage_insurancepolicy';
export const GENERATE_APPOINTMENT_WEB_LINK = 'appointments.generate_appointment_web_link';
export const APPOINTMENTS_BOOKING_UI = 'appointments.booking_ui';

export const PEOPLE_RUN_VOB = 'verifications.can_run_vob';

export const AFFECT_MESSAGES_USE_SOFTPHONE = 'affect_messages.use_softphone';

export const GENERATE_DOCUMENT = 'homebase.generate_document';

export const TREATABILITY_MATCH_VIEW = 'homebase.view_treatabilitymatch';
export const TREATABILITY_MATCH_ADD = 'homebase.add_treatabilitymatch';
export const TREATABILITY_MATCH_CHANGE = 'homebase.change_treatabilitymatch';
export const TREATABILITY_MATCH_DELETE = 'homebase.delete_treatabilitymatch';

export const TREATMENT_GROUP_VIEW = 'groups.view_treatmentgroup';
export const TREATMENT_GROUP_ADD = 'groups.add_treatmentgroup';
export const TREATMENT_GROUP_CHANGE = 'groups.change_treatmentgroup';
export const TREATMENT_GROUP_DELETE = 'groups.delete_treatmentgroup';

export const TREATMENT_GROUP_MEMBERSHIP_ADD = 'groups.add_treatmentgroupmembership';
export const TREATMENT_GROUP_MEMBERSHIP_CHANGE = 'groups.change_treatmentgroupmembership';

export const ITEM_DELETE = 'work.delete_item';

export const BLUEPRINT_VIEW = 'work.view_blueprint';
export const BLUEPRINT_ADD = 'work.add_blueprint';
export const BLUEPRINT_CHANGE = 'work.change_blueprint';
export const BLUEPRINT_DELETE = 'work.delete_blueprint';

export const ORGANIZATION_VIEW = 'people.view_organization';
export const CONTRACT_VIEW = 'contracts.view_contract';
export const ORGANIZATION_CHANGE = 'people.change_organization';
export const ORGANIZATION_DELETE = 'people.delete_organization';

export const ENCOUNTER_VIEW_BETA_TESTERS_GROUP = 'Encounter View Beta Testers';
export const ENGINEERING_GROUP = 'Engineering';
export const VOB_EDITORS_GROUP = 'VOB Editors';
export const BILLING_SUPER_ADMIN_GROUP = 'Billing - Super Admin';

/**
 * Checks if a user has the required permission(s).
 * @param params - The parameters object containing either requiredPermission or requiredPermissions, and optionally permissions.
 * @returns A boolean indicating whether the user has the required permission(s).
 */
export function hasPermission(
  params: {
    permissions?: UserPermissions;
  } & ({ requiredPermission: string } | { requiredPermissions: string[] })
) {
  const { permissions } = params;
  let reqPerms: string[];

  if ('requiredPermission' in params) {
    reqPerms = [params.requiredPermission];
  } else {
    reqPerms = params.requiredPermissions;
  }

  if (permissions?.is_super_user) {
    return true;
  }

  return reqPerms.every(
    (perm) =>
      (permissions?.user_permissions &&
        Object.values(permissions.user_permissions).includes(perm)) ||
      (permissions?.group_permissions &&
        Object.values(permissions.group_permissions).some((permissionsList) =>
          permissionsList.includes(perm)
        ))
  );
}

export function isInGroup(permissions: UserPermissions | undefined, groupName: string) {
  return !!permissions?.group_permissions?.[groupName.toLowerCase()];
}
